// ADV-1034: single source of truth for the account-level role picker. The
// API has rejected "owner" since ADV-1047 (AccountRoleSchema excludes it),
// so the option must not appear in any UI surface. Use this instead of
// re-declaring inline SelectItem lists.
//
// `value` is constrained to AccountRole minus "super_admin" — super_admin
// is never set via UI, it's promoted from supabase studio via the
// promote_to_super_admin SQL function.

import type { AccountRole } from "@adva/types";

// Internal to this module — consumers read the typed ACCOUNT_ROLE_OPTIONS
// array rather than these shapes directly, so they are not exported.
type AccountRoleOptionValue = Exclude<AccountRole, "super_admin">;

interface AccountRoleOption {
  value: AccountRoleOptionValue;
  label: string;
  description: string;
  isPrivileged: boolean;
}

export const ACCOUNT_ROLE_OPTIONS: readonly AccountRoleOption[] = [
  {
    value: "admin",
    label: "Admin",
    description:
      "Manages the account and all businesses behind it. Cannot transfer ownership.",
    isPrivileged: true,
  },
  {
    value: "billing",
    label: "Billing",
    description:
      "Limited to invoices and payment methods. Read-only on operational data.",
    isPrivileged: false,
  },
  {
    value: "viewer",
    label: "Viewer",
    description:
      "Read-only access to the account's operational data. Cannot make changes.",
    isPrivileged: false,
  },
];
